import React from 'react';
import { useNavigate } from 'react-router-dom';
import './JobsSection.css';

const JobsSection = () => {
    const navigate = useNavigate();

    const handleViewJobs = () => {
        navigate('/jobs');
    };

    const jobStats = [
        { number: '500+', label: 'Active Jobs', icon: '💼' },
        { number: '50+', label: 'Partner Hospitals', icon: '🏥' },
        { number: '₹2.5L+', label: 'Average Package', icon: '💰' },
        { number: '24hrs', label: 'Response Time', icon: '⚡' }
    ];

    const jobCategories = [
        { text: 'Doctor Positions', icon: '👨‍⚕️', count: '150+' },
        { text: 'Nursing Jobs', icon: '👩‍⚕️', count: '200-' },
        { text: 'Medical Technicians', icon: '🔬', count: '100+' },
        { text: 'Administrative Staff', icon: '📋', count: '50+' }
    ];

    const recentJobs = [
        {
            title: 'Senior Cardiologist',
            company: 'Apollo Hospitals',
            location: 'Bangalore',
            package: '₹18-25 LPA',
            urgent: true
        },
        {
            title: 'ICU Nurse',
            company: 'Max Healthcare',
            location: 'Delhi',
            package: '₹5-7 LPA',
            urgent: false
        },
        {
            title: 'Lab Technician',
            company: 'Fortis Healthcare',
            location: 'Mumbai',
            package: '₹4-6 LPA',
            urgent: true
        }
    ];

    return (
        <section className="jobs-section meddylist-jobs">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="jobs-content">
                            <div className="section-badge">
                                <span className="badge-icon">💼</span>
                                <span className="badge-text">Medical Jobs</span>
                            </div>
                            
                            <h2 className="section-title">
                                Find Your Dream
                                <span className="highlight"> Medical Job</span>
                            </h2>
                            
                            <p className="section-description">
                                Discover exciting career opportunities in India's top hospitals and medical centers. 
                                Join thousands of healthcare professionals advancing their careers.
                            </p>

                            <div className="categories-list">
                                {jobCategories.map((category, index) => (
                                    <div key={index} className="category-item">
                                        <span className="category-icon">{category.icon}</span>
                                        <span className="category-text">{category.text}</span>
                                        <span className="category-count">{category.count}</span>
                                    </div>
                                ))}
                            </div>

                            <div className="recent-jobs-preview">
                                <h4 className="preview-title">Latest Job Openings</h4>
                                <div className="jobs-list-preview">
                                    {recentJobs.slice(0, 2).map((job, index) => (
                                        <div key={index} className="preview-job-item">
                                            <div className="job-info">
                                                <div className="job-title">{job.title}</div>
                                                <div className="job-company">{job.company}</div>
                                                <div className="job-details">
                                                    <span className="job-location">{job.location}</span>
                                                    <span className="job-package">{job.package}</span>
                                                </div>
                                            </div>
                                            {job.urgent && <div className="urgent-badge">Urgent</div>}
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="cta-section">
                                <button 
                                    className="btn btn-primary btn-lg me-3"
                                    onClick={handleViewJobs}
                                >
                                    Browse All Jobs
                                </button>
                                <button 
                                    className="btn btn-outline-primary btn-lg"
                                    onClick={handleViewJobs}
                                >
                                    Upload Resume
                                </button>
                            </div>

                            <div className="trust-indicators">
                                <span className="trust-text">Join 10K+ healthcare professionals</span>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="stats-container">
                            <div className="stats-grid">
                                {jobStats.map((stat, index) => (
                                    <div key={index} className="stat-card">
                                        <div className="stat-icon">{stat.icon}</div>
                                        <div className="stat-number">{stat.number}</div>
                                        <div className="stat-label">{stat.label}</div>
                                    </div>
                                ))}
                            </div>
                            
                            <div className="jobs-hero-image">
                                <div className="featured-job">
                                    <div className="job-featured-tag">
                                        <div className="job-icon">🏥</div>
                                        <div className="job-text">
                                            <div className="job-title-featured">Senior Cardiologist</div>
                                            <div className="job-subtitle">Apollo Hospitals, Bangalore</div>
                                            <div className="job-highlights">
                                                <span className="highlight-badge">Featured</span>
                                                <span className="salary-badge">₹25L</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="job-ranking-badge">
                                        <span className="ranking-icon">⭐</span>
                                        <span className="ranking-text">Top Rated</span>
                                    </div>
                                </div>

                                <div className="floating-elements">
                                    <div className="floating-badge badge-1">
                                        <span>150+ Doctors</span>
                                    </div>
                                    <div className="floating-badge badge-2">
                                        <span>200+ Nurses</span>
                                    </div>
                                    <div className="floating-badge badge-3">
                                        <span>50+ Hospitals</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default JobsSection;
